<template>
  <v-dialog :key="changeKey" v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <v-card-text class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        
        <div class="col">
          <div class="logo text-center my-6">
            <h3 v-if="editOrCreateType === 'create'">{{ "lng_create_new_user_txt" | translate }}</h3>
            <h3 v-if="editOrCreateType === 'edit'">{{ "lng_edit_txt" | translate }} {{ getTextBasedOnRoles(authLevelDropDown) }}</h3>
            <!-- <h3>{{ dialogTitle }}</h3> -->
          </div>
          <div class="signup-form">
            <v-form ref="userInfo" lazy-validation>
              <v-select
                :disabled="authLevelDropDown == 3 ? false : true"
                class="mt-0 pt-0" solo
                :items="userRoles"
                :value="selectedUserRole.name"
                item-text="name"
                item-value="name"
                menu-props="auto"
                :label="'lng_select_user_role_txt' | translate"
                return-object
                @change="value => { selectedUserRole = value; }"
              >
                <template v-slot:selection="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
                <template v-slot:item="{ item, index }">
                  <span class="flags pl-2">{{ item.name | translate }}</span>
                </template>
              </v-select>
              <v-text-field
                :label="'lng_email_text' | translate"
                type="email"
                v-model="email"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
              <v-text-field
                :label="'lng_invoice_email_text' | translate"
                type="email"
                v-model="invoiceemail"
                :rules="[rules.email]"
              ></v-text-field>
              <v-text-field
                :label="'lng_th_companyName_txt' | translate"
                v-model="companyname"
              ></v-text-field>
              <v-text-field
                :label="'lng_th_cvr_txt' | translate"
                v-model="cvr"
              ></v-text-field>
              <v-text-field
                :label="'lng_name_text' | translate"
                v-model="name"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                :label="'lng_address1_text' | translate"
                v-model="address1" :rules="[rules.required]"></v-text-field>
              <v-text-field
                :label="'lng_address2_text' | translate"
                v-model="address2"></v-text-field>
              <v-row>
                <v-text-field
                  style="margin-right: 15px; margin-left: 15px;"
                  :label="'lng_zip_text' | translate"
                  v-model="zip"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  style="margin-right: 15px; margin-left: 15px;"
                  :label="'lng_city_text' | translate"
                  v-model="city"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-row>
              <!-- <v-text-field label="Country" name="country" type="text"></v-text-field> -->
              <v-select
                class="mt-0 pt-0"
                :items="countryItems"
                :value="selectedCountry.value"
                item-text="name"
                item-value="value"
                menu-props="auto"
                return-object
                @change="
                    value => {
                      selectedCountry = value;
                    }
                  "
              ></v-select>
              <v-text-field
                :label="'lng_new_pass_txt' | translate"
                v-model="newPass"></v-text-field>
              <v-text-field
                :label="'lng_retype_pass_text' | translate"
                v-model="retypeNewPass"></v-text-field>
              <p class="warning-error mt-2" v-if="error">{{ error }}</p>
              <div class="date-header d-flex justify-content-center py-5 mt-3">
                <v-btn
                  :loading="showLoading"
                  color="#0B7894"
                  dark
                  @click="validate"
                >
                {{editOrCreateType === 'create' ? "lng_create_new_user_txt" : "lng_edit_txt" | translate }}</v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </v-card-text>
      <Alert
        v-if="alertToggle"
        :message-data="flashMessageData"
        :alert-toggle="alertToggle"
        @alertToggleUpdate="alertToggle = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { countries, userRoles } from "../../common/Constant";
import UserService from "../../services/user-service";
import GlobalService from "../../services/global-service";
import { translateFunc } from '../../common/Filters.js';
import Alert from "../../components/Alert"
import { getTextBasedOnRoles } from "../../common/HelperFunctions"

export default {
  name: "CreateEditUser",
  components: {
    Alert
  },
  props: {
    editOrCreateType: {
      type: String,
      default: "create"
    },
    userDataProp: {
      type: Object,
      default: () => {}
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    changeKey: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    authLevelDropDown:'',
    dialog: false,
    showLoading: false,
    error: "",
    email: "",
    invoiceemail: "",
    companyname: "",
    cvr: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    zip: "",
    error: "",
    rules: {
      required: value => !!value || translateFunc("lng_required_text"),
      counter: value => value.length <= 20 || translateFunc("lng_required_length"),
      email: value => {
        if (!value) return true;
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || translateFunc("lng_required_validate_email");
      }
    },
    countryItems: countries,
    selectedCountry: {
      name: "Denmark",
      value: "DK"
    },
    userToken: undefined,
    alertToggle: false,
    flashMessageData: {},
    newPass: "",
    retypeNewPass: "",
    userData: undefined,
    userRoles: userRoles,
    selectedUserRole: { name: "Dealer", value: "0" },
  }),
  mounted() {
    this.userToken = sessionStorage.getItem("userToken");
    this.authLevelDropDown = sessionStorage.getItem("authLevel");
  },
  watch: {
    userDataProp: function(newVal) {
      if(newVal){
        this.userData = newVal;
        this.assignValues();
      }
    },
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  },
  methods: {
    getTextBasedOnRoles,
    changeTab(tabnumber){
      this.activeTab = tabnumber;
    },
    assignValues() {
      if (this.userData && Object.keys(this.userData).length ) {
        this.email = this.userData.email;
        this.invoiceemail = this.userData.invoiceemail;
        this.companyname = this.userData.companyname;
        this.cvr = this.userData.cvr;
        this.name = this.userData.name;
        this.address1 = this.userData.address1;
        this.address2 = this.userData.address2;
        this.city = this.userData.city;
        this.zip = this.userData.zip;
        // country
        let index = countries.findIndex( e => e.name === this.userData.country );
        if (index !== -1) { this.selectedCountry = countries[index]; }
        // role
        let roleind = userRoles.findIndex( e => e.value === this.userData.authlevel );
        if (roleind !== -1) { this.selectedUserRole = userRoles[roleind]; }
      } else {
        this.email = "";
        this.invoiceemail = "";
        this.companyname = "";
        this.cvr = "";
        this.name = "";
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.zip = "";
        this.newPass = "";
        this.retypeNewPass = "";
        this.selectedUserRole= { name: "Dealer", value: "0" }
        // this.fetchUserInfo(this.userToken);
      }
    },
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.userInfo.validate()) {
          // await this.signup();
          if (  this.address1 !== this.userData.address1 ||
                this.address2 !== this.userData.address2 ||
                this.city !== this.userData.city ||
                this.zip !== this.userData.zip ||
                this.selectedCountry !== this.userData.country
          ) {
            await this.getLatLng();
          } else {
            this.changeUserData({});
          }
        }
      });
      // this.openBoxModal = true;
    },

    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        if(this.editOrCreateType === 'create'){
          await this.createNewUser(location.results[0].geometry.location);
        } else {
          await this.changeUserData(location.results[0].geometry.location);
        }
      } else {
        console.log("location not found");
        this.error = translateFunc("lng_missing_city_txt");
        this.showAlert({msg: translateFunc("lng_missing_city_txt"), status: 1});
      }
    },

    async changeUserData(location) {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        let paramString = "";
        if (location.lat && location.lng) {
          paramString = `dealerid=${this.userData.id}&email=${this.email}&invoiceemail=${encodeURIComponent(this.invoiceemail)}&companyname=${encodeURIComponent(this.companyname)}&cvr=${encodeURIComponent(this.cvr)}&name=${this.name}&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(this.address2)}&city=${this.city}&zip=${this.zip}&country=${this.selectedCountry.name}&authlevel=${this.selectedUserRole.value}&lat=${location.lat}&lng=${location.lng}`;
        } else {
          paramString = `dealerid=${this.userData.id}&email=${this.email}&invoiceemail=${encodeURIComponent(this.invoiceemail)}&companyname=${encodeURIComponent(this.companyname)}&cvr=${encodeURIComponent(this.cvr)}&name=${this.name}&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(this.address2)}&city=${this.city}&zip=${this.zip}&country=${this.selectedCountry.name}&authlevel=${this.selectedUserRole.value}`;
        }
        if(this.newPass){
          if(this.newPass === this.retypeNewPass){
            paramString = paramString + `&password=${this.newPass}`;

            response = await UserService.changeUserInfo(
              this.userToken,
              paramString
            );
          } else {
            response = {msg: translateFunc("lng_password_mismatch_txt"), status: 1}
          }
        } else {
          response = await UserService.changeUserInfo(
            this.userToken,
            paramString
          );
        }
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        this.showAlert({msg: translateFunc("lng_try_again_txt"), status: 1});
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        // this.showAlert(response);
        this.$emit("refreshUsers");
        this.closeDialog();
      } else {
        this.showLoading = false;
        this.error = response.msg;
        this.showAlert(response);
      }
    },

    async createNewUser(location) {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        if(this.newPass){
          if(this.newPass === this.retypeNewPass){

            response = await UserService.createUserByAdmin(
              this.userToken,
              this.email,
              this.newPass,
              this.name,
              this.address1,
              this.address2,
              this.city,
              this.zip,
              this.selectedCountry.name,
              location.lat,
              location.lng,
              this.selectedUserRole.value,
              this.companyname,
              this.cvr,
              this.invoiceemail
            );
          } else {
            response = {msg: translateFunc("lng_password_mismatch_txt"), status: 1}
          }
        } else {
          response = {msg: translateFunc("lng_password_mismatch_txt"), status: 1}
        }
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        console.log("e: ", e);
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        // this.showAlert(response);
        this.$emit("refreshUsers");
        this.closeDialog();
      } else {
        this.showLoading = false;
        this.error = response.msg;
      }
    },

    async fetchUserInfo(token) {
      let userData = await GlobalService.getUserInfo(token);
      if (userData.dealer) {
        this.userData = userData.dealer;
        this.assignValues();
      }
    },
    showAlert(res){
      this.flashMessageData = res;
      this.alertToggle = true;
    }
  }
};
</script>